module.exports = __webpack_public_path__ + "img/ee384a38dabdd02d4ef0ada211a6af98.png";